import React from 'react';
import { ToolTipController, Select } from 'react-tooltip-controller';
import * as Ui from './activemenu.styles';

export default function ActivePopupMenu({
  // valor do item selecionado
  isActived,
  // propaga o evento de seleção
  onActive,
  // para o componente filho
  children,
  // classes de estilos
  className,
}) {
  // constants
  const activeValue = 'ativo';
  const inactiveValue = 'inativo';

  // manipula a seleção do item
  function handleChangeActive(actived) {
    if (onActive) onActive(actived);
  }

  function renderPopupBody() {
    return (
      <Ui.Container>
        <Ui.InnerContainer>
          {/* active */}
          <Ui.Row>
            <Ui.Radio
              name={'popup'}
              id={activeValue}
              label={activeValue}
              value={activeValue}
              checked={isActived}
              onChange={() => handleChangeActive(true)}
            />
          </Ui.Row>
          {/* inactive */}
          <Ui.Row>
            <Ui.Radio
              className={'inactive'}
              name={'popup'}
              id={inactiveValue}
              label={inactiveValue}
              value={inactiveValue}
              checked={!isActived}
              onChange={() => handleChangeActive(false)}
            />
          </Ui.Row>
        </Ui.InnerContainer>
      </Ui.Container>
    );
  }

  return (
    <ToolTipController detect="click" offsetY={-5}>
      <Select>
        <Ui.Clicable className={className}>{children}</Ui.Clicable>
      </Select>
      { renderPopupBody() }
    </ToolTipController>
  );
}
